export const strings = {
  title: 'Exams',
  subtitle: 'One exam per course, and the rules that compose its questions',
  create: 'New Exam',
  close: 'Close',
  save: 'Save',
  saved: 'Saved successfully',
  deleted: 'Deleted successfully',
  actionFailed: 'The operation could not be completed',
  fail: {
    list: 'Could not load the exams',
    load: 'Could not load this exam',
    save: 'Could not save the exam',
    delete: 'Could not delete the exam',
  },
  deleteConfirm: 'Are you sure you want to delete this exam?',
  allCoursesHaveExam: 'Every course already has an exam',

  columns: {
    index: 'ID',
    course: 'Course',
    name: 'Exam Name',
  },

  row: {
    edit: 'Update',
    delete: 'Delete',
  },

  form: {
    editTitle: 'Update Exam',
    createTitle: 'New Exam',
    course: 'Course',
    nameAr: 'Arabic Name',
    nameEn: 'English Name',
    passLimit: 'Pass Mark',
    tries: 'Attempts',
    forceWatch: 'Require watching the content',
    hideAnswers: 'Hide answers',
    preventIfSucceeded: 'Prevent retaking after a pass',
    rewatch: 'Re-watch percentage on failure',
    required: 'This field is required',
  },

  rules: {
    viewQuestions: 'View questions',
    hideQuestions: 'Hide questions',
    questions: (count) => `${count} ${count === 1 ? 'question' : 'questions'}`,
    draws: (count, total) => `Each attempt draws ${count} of these ${total}`,
    shortfall: (total, count) => `Only ${total} in the bank at this difficulty; the rule asks for ${count}`,
    noQuestions: 'No questions at this difficulty in the topic’s bank',
    loadingQuestions: 'Loading questions…',
    questionsFailed: 'Could not load the questions. Open the question bank to try again.',
    manageQuestions: 'Manage question bank',
    title: 'Question Rules',
    topic: 'Topic',
    level: 'Difficulty',
    count: 'Questions',
    available: 'Available',
    total: 'Questions per attempt',
    add: 'Add rule',
    remove: 'Remove',
    empty: 'No rules added yet',
    tooMany: 'More questions than are available',
  },
}
